exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Hind+Madurai:400,700);", ""]);
var urlEscape = require("../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("assets/fonts/HindMysuru-Bold.otf"));

// Module
exports.push([module.id, "@font-face{font-family:\"HindMysuru-Bold\";src:url(" + ___CSS_LOADER_URL___0___ + ") format(\"opentype\")}.button[data-v-89854200]{background:none;min-width:none;box-shadow:none;font-style:normal;font-weight:500;font-size:14px;color:#ff4848;margin:auto}.button[data-v-89854200]:hover{text-decoration:underline}.icon[data-v-89854200]{overflow:visible;margin-bottom:-4%;margin-right:4px}\n", ""]);

